<template>
  <div class="com-game-card" @click="openGameDetail">
    <OutOpen
      :protocol="heyboxProtocol"
      :page-identifier="'bbs/link'"
      v-if="canUseDeepLink && articleInfo.source == 'share'"
    ></OutOpen>
    <template v-if="!is_loading">
      <div class="game-img-wrapper" v-report.exposure="getReportConfig">
        <img v-hb-img.src="card_data.image" alt="" class="game-img" />
        <div class="platform-icon-list">
          <img
            v-for="url in card_data.platforms_icon"
            :key="url"
            v-hb-img.src="url"
            alt=""
            class="platform-icon-item"
          />
        </div>
        <!-- <div class="static-color-follow-box" v-if="card_data.follow_num">
          <hb-icon name="bbs-like" />
          <span
            class="follow-num"
            :class="{ ellipsis: card_data.follow_num > 10000 }"
            >{{ followNum }}</span
          >
        </div> -->
        <div
          class="static-color-game-score"
          :style="{ background: scoreColor }"
          v-if="gameScore !== '暂无评分'"
        >
          <hb-icon name="bbs-heybox-platform_v" />
          <span class="game-score-item impact">{{ gameScore }}</span>
        </div>
        <div class="static-color-discount-box" v-if="discount">
          -{{ discount }}%
        </div>
      </div>
      <div class="game-info">
        <p class="line-1">{{ card_data.name }}</p>
        <div class="line-2">
          <div class="price-box" :style="{ visibility: hiddenPrice }">
            <div class="price-content-box">
              <template v-if="this.card_data.is_free || current_price">
                <template v-if="this.card_data.is_free">
                  <span class="current-price">免费</span>
                </template>
                <template v-else>
                  <hb-icon :name="platform" />
                  <hb-icon bbs-money />
                  <span class="current-price">{{ current_price }}</span>
                </template>
                <p class="original-price" v-if="discount">
                  <hb-icon bbs-money />
                  <span class="price-num">{{ original_price }}</span>
                </p>
              </template>
              <template v-else-if="this.card_data.release_date">
                <span
                  class="release-time"
                  :class="{ 'alibaba-font': release_desc.alibaba }"
                  >{{ release_desc.time }}</span
                >
                <span class="release-desc">{{ release_desc.desc }}</span>
              </template>
            </div>
            <!-- <div class="static-color-discount-box" v-if="discount">
              -{{ discount }}%
            </div> -->
            <div class="static-color-tag-box" v-if="discount_desc">
              {{ discount_desc }}
            </div>
          </div>
          <!-- <div
            class="follow-btn"
            :class="{ follow: is_follow }"
            @click="onClickBtn"
          >
            {{
              is_follow
                ? card_data.follow_state == 'owned'
                  ? '已拥有'
                  : '已关注'
                : '关注'
            }}
          </div> -->
          <div
            class="follow-box"
            :class="{ 'static-color-active': is_follow }"
            v-if="card_data.follow_num"
            @click="onClickBtn"
          >
            <template v-if="card_data.follow_state == 'owned'">
              <span class="had-tag">已拥有</span>
            </template>
            <template v-else>
              <hb-icon name="bbs-like" />
              <span
                class="follow-num alibaba-font"
                :class="{ ellipsis: card_data.follow_num > 10000 }"
                >{{ followNum }}</span
              >
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin';
import { executeProtocol, executeProtocolOutApp } from '_lib/utils';
import { toggleFollowGameState } from '_api/bbs/post-article/index';
import { HeyboxReportDirectiveOptions } from '_lib/plugin/heybox-report';
import moment from 'moment';
import OutOpen from '_com/OutOpen';
export default {
  mixins: [CptMixin],
  props: {
    canUseDeepLink: {
      type: Boolean,
    },
  },
  data() {
    return {
      is_loading: true,
      card_data: {},
      is_follow: false,
      platform: 'bbs-heybox-platform_v', // 平台
      current_price: '', // 当前价格
      original_price: '', // 原价
      discount: '', // 折扣
      discount_desc: '', // 折扣描述
    };
  },
  created() {
    this.getData();
  },
  components: {
    OutOpen,
  },
  methods: {
    async getData() {
      // const { data: {result, status}} = await this.articleInfo.requestCardData(this.dataInfo.type)
      const {
        data: { result, status },
      } = await this.dataInfo.request;
      if (status != 'ok') {
        return;
      }
      this.card_data = result.base_infos.find(
        (item) => item.steam_appid == this.dataInfo.id,
      );
      if (!this.card_data) return;
      this.handleGamePrice();
      this.is_follow = this.card_data.follow_state != 'unfollowing';
      this.is_loading = false;
    },
    handleGamePrice() {
      if (
        this.card_data.platform_infos &&
        this.card_data.platform_infos[0] &&
        this.card_data.platform_infos[0].price
      ) {
        let price = this.card_data.platform_infos[0].price;
        switch (this.card_data.platform_infos[0].key) {
          case 'ps4': {
            this.platform = 'bbs-ps-platform';
            break;
          }
          case 'xbox': {
            this.platform = 'bbs-xbox-platform';
            break;
          }
          case 'switch': {
            this.platform = 'bbs-switch-platform';
            break;
          }
          default: {
            this.platform = 'bbs-heybox-platform_v';
          }
        }
        if (price.discount && price.discount > 0) {
          this.original_price = price.initial;
          this.discount = price.discount;
          this.discount_desc = price.discount_desc && '史低';
        }
        this.current_price = this.card_data.platform_infos[0].price.current;
      } else if (this.card_data.heybox_price) {
        this.current_price = Math.round(
          this.card_data.heybox_price.cost_coin / 1000,
        );
        if (
          this.card_data.heybox_price.cost_coin !=
          this.card_data.heybox_price.original_coin
        ) {
          this.original_price = ~~(
            this.card_data.heybox_price.original_coin / 1000
          );
        }
        if (this.card_data.heybox_price.new_lowest == 1) {
          this.discount_desc = '新史低';
        } else if (this.card_data.heybox_price.is_lowest == 1) {
          this.discount_desc = '史低';
        }
        if (
          this.card_data.heybox_price.discount &&
          this.card_data.heybox_price.discount > 0
        ) {
          this.discount = this.card_data.heybox_price.discount;
        }
      } else if (this.card_data.price) {
        this.current_price = this.card_data.price.current;
        if (
          this.card_data.price.discount &&
          this.card_data.price.discount > 0
        ) {
          this.discount = this.card_data.price.discount;
          this.original_price = this.card_data.price.initial;
        }
        if (this.card_data.price.new_lowest == 1) {
          this.discount_desc = '新史低';
        } else if (this.card_data.price.is_lowest == 1) {
          this.discount_desc = '史低';
        }
      }
    },
    async onClickBtn(e) {
      if (this.lock) return;
      this.lock = true;
      switch (this.articleInfo.source) {
        case 'share': {
          this.openGameDetail();
          break;
        }
        case 'post': {
          if (this.card_data.follow_state == 'owned') return;
          e.stopPropagation();
          const {
            data: { status, msg },
          } = await toggleFollowGameState(
            this.is_follow ? 'unfollow' : 'follow',
            {
              steam_appid: this.card_data.steam_appid,
            },
          );
          if (status != 'ok') {
            this.$hb_toast.failed(this.is_follow ? '取消关注失败' : '关注失败');
            return;
          }
          this.$hb_toast.success(this.is_follow ? '取消关注成功' : '关注成功');
          this.is_follow = !this.is_follow;
          break;
        }
      }
      this.lock = false;
    },
    openGameDetail() {
      if (!this.card_data) return;
      switch (this.articleInfo.source) {
        case 'share': {
          executeProtocolOutApp(this.heyboxProtocol);
          break;
        }
        case 'post': {
          executeProtocol({
            protocol_type: 'openGameDetail',
            app_id: this.card_data.steam_appid,
            game_type: this.card_data.game_type,
            h_src: this.articleInfo.options?.h_src ?? this.card_data.h_src,
          });
          break;
        }
      }
    },
    getReportConfig() {
      switch (this.articleInfo.source) {
        case 'share': {
          return {};
        }
        case 'post': {
          return {
            path: '/game/item/show',
            type: '3',
            addition: {
              app_id: this.card_data.steam_appid,
              idx: this.dataInfo.index,
              h_src: this.articleInfo.options?.h_src ?? this.card_data.h_src,
              link_id: this.articleInfo.origin_data.linkid,
            },
          };
        }
      }
    },
  },
  computed: {
    hiddenPrice() {
      return this.current_price ||
        this.card_data.is_free ||
        this.card_data.release_date
        ? 'visible'
        : 'hidden';
    },
    gameScore() {
      return this.card_data.score_desc
        ? this.card_data.score_desc
        : this.card_data.score
          ? Number(this.card_data.score).toFixed(1)
          : '暂无评分';
    },
    scoreColor() {
      return this.card_data.score_desc || this.gameScore === '暂无评分'
        ? '#d4d4d4'
        : this.gameScore >= 9
          ? 'rgb(254, 127, 0)'
          : this.gameScore >= 7
            ? 'rgb(198, 0, 255)'
            : this.gameScore >= 5
              ? 'rgb(0, 129, 255)'
              : 'rgb(106, 202, 63)';
    },
    followNum() {
      return this.card_data.follow_num > 10000
        ? parseFloat(Math.round(this.card_data.follow_num / 1000) / 10)
        : this.card_data.follow_num;
    },
    release_desc() {
      if (!this.card_data.release_date) {
        return null;
      } else if (this.card_data.release_timestamp) {
        return {
          alibaba: true,
          time: moment(this.card_data.release_timestamp * 1000).format(
            'YYYY.MM.DD',
          ),
          desc: '上线',
        };
      } else if (this.card_data.release_date.endsWith('年')) {
        return {
          alibaba: true,
          time: this.card_data.release_date.slice(0, -1),
          desc: '年',
        };
      } else {
        return {
          time: this.card_data.release_date,
        };
      }
    },
    heyboxProtocol() {
      return (
        'heybox://' +
        encodeURIComponent(
          JSON.stringify({
            protocol_type: 'openGameDetail',
            app_id: this.card_data.steam_appid,
            game_type: this.card_data.game_type,
          }),
        )
      );
    },
  },
  directives: {
    report: HeyboxReportDirectiveOptions,
  },
};
</script>

<style lang="less">
.com-game-card {
  position: relative;
  display: flex;
  align-items: center;
  height: 80px;
  margin-top: 12px;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(250, 251, 252, 1);
  &::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border-radius: 16px;
    border: 1px solid rgba(243, 244, 245, 1);
    transform: scale(0.5);
    transform-origin: left top;
    pointer-events: none;
  }
  .alibaba-font {
    font-family: 'ALIBABA Font' !important;
  }
  .impact {
    font-family: 'Impact' !important;
  }
  .game-img-wrapper {
    position: relative;
    width: 128px;
    height: 64px;
    .game-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
      overflow: hidden;
    }
    .platform-icon-list {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      .platform-icon-item {
        width: 14px;
        height: 14px;
        border-radius: 2px;
        &:first-of-type {
          border-radius: 4px 2px 2px 2px;
        }
      }
    }
    .static-color-game-score {
      position: absolute;
      left: -2px;
      bottom: 3px;
      display: inline-flex;
      align-items: center;
      height: 16px;
      padding: 0 4px 0 3px;
      border-radius: 3px;
      color: rgba(255, 255, 255, 1);
      i {
        font-size: 12px;
        margin-right: 1px;
      }
      .game-score-item {
        font-size: 12px;
      }
    }

    .static-color-discount-box {
      position: absolute;
      top: 0;
      right: 0;
      padding: 0 3px;
      font-size: 10px;
      font-weight: 700;
      font-family: Helvetica;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
      background: rgba(64, 68, 73, 0.8);
      color: #ffffff;
      white-space: nowrap;
      border-radius: 0 4px 0 4px;
    }
  }
  .game-info {
    flex: 1;
    width: 0;
    margin-left: 10px;
    .line-1 {
      width: 80%;
      height: 21px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(20, 25, 30, 1);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 21px;
    }
    .line-2 {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      width: 100%;
      height: 24px;
      margin-top: 2px;
      .price-box {
        display: inline-flex;
        align-items: center;
        border-radius: 2px;
        background: #f3f4f5;
        overflow: hidden;
        .price-content-box {
          display: inline-flex;
          align-items: center;
          height: 16px;
          color: rgba(20, 25, 30, 1);
          padding: 2px 2px;
          .platform-logo {
            width: 11px;
            height: 11px;
          }
          i {
            display: flex;
            width: 10px;
            font-size: 11px;
          }
          .hbicon-money {
            font-size: 10px;
          }
          .release-time {
            display: block;
            font-size: 11px;
            line-height: 16px;
            font-family: 'PingFang SC';
            white-space: nowrap;
          }
          .release-desc {
            margin-left: 2px;
            font-size: 10px;
            line-height: 16px;
            color: #8c9196;
            white-space: nowrap;
          }
          .current-price {
            font-size: 12px;
            font-weight: 700;
            line-height: 16px;
            white-space: nowrap;
          }
          .original-price {
            position: relative;
            display: inline-flex;
            align-items: center;
            font-size: 10px;
            color: rgba(140, 145, 150, 1);
            white-space: nowrap;
            &::after {
              content: '';
              position: absolute;
              top: 50%;
              left: 2px;
              width: calc(100% - 4px);
              height: 1px;
              background: rgba(140, 145, 150, 1);
            }
            i {
              line-height: 13px;
              font-weight: 400;
            }
            .price-num {
              font-size: 10px;
              white-space: nowrap;
            }
          }
        }
        .static-color-tag-box {
          padding: 0 3px;
          font-size: 10px;
          color: rgba(255, 255, 255, 1);
          line-height: 16px;
          background: #32b846;
          color: #ffffff;
          white-space: nowrap;
        }
      }
      .follow-btn {
        padding: 4px 8px;
        font-size: 12px;
        line-height: 16px;
        color: rgba(255, 255, 255, 1);
        border-radius: 3px;
        background: rgba(20, 25, 30, 1);
        white-space: nowrap;
        &.follow {
          background: rgba(243, 244, 245, 1);
          color: rgba(20, 25, 30, 1);
        }
      }
      .follow-box {
        display: inline-flex;
        align-items: center;
        height: 16px;
        padding: 0 4px 0 4px;
        border-radius: 3px;
        color: rgba(255, 255, 255, 1);
        background: #f3f4f5;
        &.static-color-active {
          i,
          .follow-num {
            background-image: linear-gradient(45deg, #ff6771 0%, #f53e59 100%);
            background-clip: text;
            color: transparent;
            &::after {
              background-image: linear-gradient(
                45deg,
                #ff6771 0%,
                #f53e59 100%
              );
              background-clip: text;
            }
          }
        }
        i {
          font-size: 12px;
          margin-right: 2px;
          color: #c8cdd2;
        }
        .follow-num {
          position: relative;
          display: inline-flex;
          align-items: center;
          margin-top: 3px;
          font-size: 12px;
          color: #14191e;
          // font-weight: 700;
          line-height: 16px;
          &.ellipsis {
            padding-right: 10px;
            &::after {
              position: absolute;
              right: -9px;
              top: 50%;
              content: '万';
              font-family: 'PingFang SC';
              font-size: 18px;
              font-weight: 600;
              transform: translate(0, -28%) scale(0.5);
              transform-origin: left top;
            }
          }
        }
        .had-tag {
          font-size: 10px;
          color: #64696e;
        }
      }
    }
  }
}
</style>
